import React from 'react';
import PropTypes from 'prop-types';

const Table = (props) => {
  const {children} = props;
  return (
      <table className="table table-hover table-striped">
        {children}
      </table>
  );
};

Table.propTypes = {
  title: PropTypes.string
};

export default Table;





// WEBPACK FOOTER //
// ./src/component/Table/Table.js